'use client';

import { useEffect, useState } from 'react';

import { ProductValidatorModal } from '@/components';
import { MenuService, useEcomStoreSelector, useUiStoreSelector } from '@/data';

const StoreValidator = () => {
  const {
    line_items,
    next_store_id,
    next_shop_mode,
    next_delivery_address,
    setState,
  } = useEcomStoreSelector([
    'line_items',
    'next_store_id',
    'next_shop_mode',
    'next_delivery_address',
  ]);

  const [outsideProducts, setOutsideProducts] = useState([]);
  const { getInsideStoreProducts, getOutsideProducts } = new MenuService();
  const { setState: setUiState, is_store_validator_modal_open } =
    useUiStoreSelector(['is_store_validator_modal_open']);

  const confirmShopChange = async () => {
    let storeProducts = await getInsideStoreProducts(line_items, next_store_id);

    storeProducts = storeProducts?.map(item => {
      const cartItem = line_items.find(s => s.id === item.id);
      return {
        ...item,
        quantity: cartItem.quantity,
        weightVariant: cartItem.weightVariant,
      };
    });

    setState({
      delivery_address: next_delivery_address,
      delivery_details: {
        delivery: next_shop_mode === 'delivery',
        pickup: next_shop_mode === 'pickup',
      },
      treez_store_name: next_store_id,
      line_items: storeProducts,
      next_store_id: null,
      next_delivery_address: null,
    });

    setOutsideProducts([]);
  };

  const confirmKeepShop = () => {
    setState({
      next_shop_mode: null,
      next_store_id: null,
    });
  };

  useEffect(() => {
    setUiState({ is_store_validator_modal_open: !!next_store_id });
  }, [next_store_id]);

  useEffect(() => {
    if (!is_store_validator_modal_open) {
      return;
    }

    const loadOutsideProducts = async () => {
      const products = await getOutsideProducts(line_items, next_store_id);

      setOutsideProducts(products);
    };

    loadOutsideProducts();
  }, [is_store_validator_modal_open]);

  return (
    <ProductValidatorModal
      // eslint-disable-next-line max-len
      alertMessage="Be careful! You are about to change the shop. Some of your items will be removed from your shopping cart"
      cancelButtonLabel="Keep item & don’t change shop"
      handleCloseModal={confirmKeepShop}
      handleSubmit={confirmShopChange}
      heading="Do you want to change shops?"
      isModalOpen={is_store_validator_modal_open}
      products={outsideProducts}
      submitButtonLabel="remove item & change shop"
    />
  );
};

export { StoreValidator };
